// extracted by mini-css-extract-plugin
export const mobileAppBadges = "MobileAppBadges__mobileAppBadges__wl84p";